import { brand } from '../brand.config';

export { brand };

export function hexToRgb(hex) {
  const h = hex.replace('#', '');
  return [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16));
}

// '#D4A5A5' -> 'H S% L%' (formato de las variables HSL de shadcn)
function hexToHsl(hex, lightness) {
  const [r, g, b] = hexToRgb(hex).map((v) => v / 255);
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const l = (max + min) / 2;
  let h = 0;
  let s = 0;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
    else if (max === g) h = (b - r) / d + 2;
    else h = (r - g) / d + 4;
    h *= 60;
  }
  const L = lightness !== undefined ? lightness : Math.round(l * 100);
  return `${Math.round(h)} ${Math.round(s * 100)}% ${L}%`;
}

const kebab = (s) => s.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`);

// Vuelca la configuración de marca a :root. Se llama una vez antes de renderizar.
export function applyBrand() {
  const root = document.documentElement;
  Object.entries(brand.colors).forEach(([key, hex]) => {
    const name = kebab(key);
    root.style.setProperty(`--brand-${name}`, hex);
    root.style.setProperty(`--brand-${name}-rgb`, hexToRgb(hex).join(' '));
  });
  root.style.setProperty('--brand-font-head', brand.fonts.head);
  root.style.setProperty('--brand-font-body', brand.fonts.body);
  root.style.setProperty('--brand-font-serif', brand.fonts.serif);

  if (brand.overrideShadcn) {
    const { primary, onPrimary, text } = brand.colors;
    root.style.setProperty('--primary', hexToHsl(primary));
    root.style.setProperty('--primary-foreground', hexToHsl(onPrimary));
    root.style.setProperty('--ring', hexToHsl(primary));
    root.style.setProperty('--chart-1', hexToHsl(primary));
    root.style.setProperty('--accent', hexToHsl(primary, 94));
    root.style.setProperty('--accent-foreground', hexToHsl(primary, 30));
    root.style.setProperty('--foreground', hexToHsl(text));
    root.style.setProperty('--card-foreground', hexToHsl(text));
    root.style.setProperty('--popover-foreground', hexToHsl(text));
    root.style.setProperty('--secondary-foreground', hexToHsl(text));
  }
  document.title = brand.name;
}
